<template>
  <v-layout row wrap align-center justify-center v-if="isVisible">
    <v-flex xs12 sm6>
      <v-card>
        <v-card-title>
          <h1>Доступ запрещён</h1>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          У вас нет прав для доступа в iLab
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="success"
            text
            href="/"
          >
            Войти повторно
          </v-btn>

          <v-btn
            color="success"
            text
            @click="logout"
          >
            Выйти из Azure
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>

import {API} from "@/utils/api";
import CurrentUser from "@/orm/models/CurrentUser";
import STORE from "@/store/STORE";

const { actions: currentUserActions } = STORE.modules.currentUser;

export default {
  name: 'Forbidden',
  data() {
    return {
      isVisible: false
    }
  },
  async mounted() {

    try {
      await CurrentUser.dispatch(currentUserActions.getCurrentUser);
      const user = await CurrentUser.query().first();
      await CurrentUser.dispatch(currentUserActions.setCurrentUser, user);

      if (user) {
        this.$router.push({ path: '/' });
      }
    } catch {
      this.isVisible = true;
    }
  },
  methods: {
    async logout() {
      await API.get('/sso/create_logout_link/').then(responce => {
          window.location = responce.data.logout_link;
        })
    }
  }
};
</script>
